<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="homeclubbox">
      <div class="topbox">
        <swiper :options="swiperOption" ref="mySwiper" class="matchswiper">
          <!-- slides -->
          <!-- <swiper-slide>
            <div class="swiperitem">
              <img src="~assets/images/club/clubimg.jpg" />
            </div>
          </swiper-slide> -->

          <swiper-slide
            v-for="item in this.clubdes.clubImageList"
            :key="item.id"
          >
            <div class="swiperitem">
              <img :src="item.imageUrl" />
            </div>
          </swiper-slide>

          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
      </div>

      <div class="clubdesbox">
        <div class="destitle">俱乐部介绍</div>
        <div class="descontent">
          <div class="clubnamebox">
            <div class="logoitem">
              <img :src="clubdes.clubImage" />
            </div>
            <div class="clubname">{{ clubdes.clubName }}</div>
          </div>
          <p>{{ clubdes.introduce }}</p>
        </div>
      </div>

      <div class="teachdesbox" v-if="isshowtech">
        <div class="destitle">教练团队</div>
        <div class="teachbox">
          <swiper :options="swiperOption" ref="mySwiper" class="techswiper">
            <!-- slides -->
            <!-- <swiper-slide>
              <div class="teachitem">
                <div class="teachitemimg">
                  <img src="~assets/images/club/tech.jpg" />
                </div>
                <div class="teachitemname">{{ clubdes.coachName }}</div>
              </div>
            </swiper-slide> -->

            <swiper-slide
              v-for="item in this.clubdes.clubCoachList"
              :key="item.id"
            >
              <div class="teachitem">
                <div class="teachitemimg">
                  <img :src=" item.imageUrl" />
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-scrollbar" slot="scrollbar"></div>
          </swiper>
        </div>
      </div>

      <div class="newsdesbox" v-if="isshownews">
        <div class="destitle">俱乐部动态</div>
          <div class="newsitem" v-for="item in this.clubdes.clubNewsList" :key="item.id">
        <!-- <div class="newsitem"> -->
          <div class="newstitle">{{item.newsTitle}}</div>
          <div class="newsimage">
            <img :src="item.titleImageUrl" />
          </div>
          <div class="newscontent" v-html="item.newsContent"></div>
        </div>
      </div>
    </div>
    　
    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "clubdes",
  data() {
    return {
      imageurl: BaseUrl,
      clubid: 1,
      clubdes: {},
      isshowtech: true,
      isshownews: true,
      swiperOption: {
        scrollbar: ".swiper-scrollbar",
        scrollbarHide: false,
        // slidesPerView: 'auto',
        // centeredSlides: true,
        spaceBetween: 30,
        grabCursor: true,
        width: window.innerWidth * 0.57,
        slidesPerView: 2.5,
        onSlideChangeEnd: (swiper) => {
          this.page = swiper.realIndex + 1;
          this.index = swiper.realIndex;
        },
      },
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function () {
      this.$router.push({
        name: "Home",
      });
    },

    async GetClueDes() {
      // console.log(this.token);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          id: this.clubid,
        };

        const url = "https://ttserver.aizhuotice.online/api/v1/clubInfo";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            // token: this.token,
          },
        });

        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        // console.log(this.response);
        if (this.response.code == 200) {
          // console.log(this.response.data);
          this.clubdes = this.response.data;
          console.log(this.clubdes);
          if (this.clubdes.clubCoachList.length > 0) {
            this.isshowtech = true;
          } else {
            this.isshowtech = false;
          }
          // console.log(this.clubdes.clubName);
        } else {
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    this.clubid = this.$route.params.id;
    // console.log(this.$route.params);
    console.log(this.clubid);
    console.log("BaseUrl=" + BaseUrl);
    if (this.clubid == null) {
      this.clubid = 1;
    }
    this.GetClueDes();
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.homeclubbox {
  width: 100vw;
  height: auto;
  position: relative;
  background-color: #181818;
}

.hometiebtnimg {
  position: absolute;
  top: 37.5vw;
  left: 38vw;
  width: 25.5vw;
  height: 5.5vw;
}

.hometiebtnimg img {
  width: 100%;
  height: 100%;
}

.topbox {
  width: 100%;
  height: 18vw;
  background-color: #181818;
  position: relative;
}
.matchswiper {
  position: relative;
  top: 0vw;
  left: 0;
  width: 100%;
  height: 18vw;
}

.swiperitem {
  width: 23vw;
  height: 16vw;
  overflow: hidden; /* 超出部分隐藏 */
}
.swiperitem img {
  width: 100%; /* 图片宽度自适应 */
  height: 100%; /* 固定图片高度为容器高度 */
  object-fit: cover; /* 裁剪图片以保持比例 */
  display: block; /* 避免 inline 元素的默认行为 */
  overflow: hidden;
}

.swiper-scrollbar {
  background: #fff;
  width: 80vw;
  left: 10vw;
  height: 0.5vw;
}

.clubdesbox {
  position: relative;
  width: 94vw;
  left: 3vw;
  height: auto;
  top: 1vw;
  padding-bottom: 5vw;
  background-color: #181818;
}
.destitle {
  position: relative;
  top: 0;
  left: 0;
  width: 91vw;
  height: 3vw;
  color: #fff;
  font-size: 2vw;
  padding-left: 3vw;
  background-color: #a81f24;
}
.destitle p {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 3vw;
  line-height: 3vw;
  color: #fff;
  font-size: 2vw;
}
.descontent {
  position: relative;
  width: 94vw;
  left: 0vw;
  top: 1vw;
  font-size: 1.3vw;
  padding-left: 3vw;
  padding-right: 3vw;
  /* height: 100%; */
  background-color: #181818;
}
.descontent p {
  position: relative;
  top: 2vw;
  left: 0;
  width: 100%;
  /* height: 100%; */
  color: #fff;
  font-size: 1.3vw;
}
.clubnamebox {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 7vw;
  /* background-color: #181818; */
}
.logoitem {
  position: relative;
  top: 0;
  left: 0;
  width: 7vw;
  height: 7vw;
  background-color: #181818;
}
.logoitem img {
  width: 100%;
  height: 100%;
}
.clubname {
  position: absolute;
  top: 2.5vw;
  left: 10vw;
  width: 100%;
  color: #fff;
  font-size: 2vw;
}
.teachdesbox {
  position: relative;
  width: 94vw;
  left: 3vw;
  height: auto;
  top: 1vw;
  padding-bottom: 5vw;
  background-color: #181818;
}
.teachbox {
  position: relative;
  top: 0vw;
  left: 0;
  width: 100%;
  height: 27vw;
}
.techswiper {
  position: relative;
  top: 0vw;
  left: 0;
  width: 100%;
  height: 30vw;
}
.teachitem {
  position: relative;
  width: 20vw;
  height: 30vw;
  overflow: hidden; /* 超出部分隐藏 */
}

.teachitem img {
  width: 100%; /* 图片宽度自适应 */
  height: 100%; /* 固定图片高度为容器高度 */
  object-fit: cover; /* 裁剪图片以保持比例 */
  display: block; /* 避免 inline 元素的默认行为 */
  overflow: hidden;
}
.newsdesbox {
  position: relative;
  width: 94vw;
  left: 3vw;
  height: auto;
  top: 1vw;
  padding-bottom: 5vw;
  background-color: #181818;
}

.newsitem{
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 11vw;
}
.newstitle{
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 3vw;
  line-height: 3vw;
  color: #a81f24;
  font-size: 1.6vw;
  font-weight: bold;
  border-bottom: 2px solid #a81f24;

}
.newsimage{
  position: relative;
  top: 0.8vw;
  left: 0;
  width: 10vw;
  height: 5vw;
}
.newsimage img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.newscontent{
  position: absolute;
  top: 3.8vw;
  left: 13vw;
  width: 65vw;
  height: 5vw;
  color: #fff;
  font-size: 1.3vw;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

</style>



// WEBPACK FOOTER //
// src/components/clubdes.vue